import tmhRequest from "@/config/tmhRequest";

export default {
  searchTargetQuestion: function (data) {
    return tmhRequest({
      url: "/health/tmh/healthreport/searchtargetquestion",
      method: "get",
      params: data,
    });
  },

  searchHealthReport: function (data) {
    return tmhRequest({
      url: "/health/tmh/healthreport/searchhealthreport",
      method: "get",
      params: data,
    });
  },

  searchLatelyHealthReport: function (data) {
    return tmhRequest({
      url: "/health/tmh/healthreport/searchlatelyhealthreport",
      method: "get",
      params: data,
    });
  },

  searchHealthScreenReport: function (data) {
    return tmhRequest({
      url: "/health/tmh/healthreport/searchhealthscreenreport",
      method: "get",
      params: data,
    });
  },

  searchAnxietyReport: function (data) {
    return tmhRequest({
      url: "/health/tmh/healthreport/searchanxietyreport",
      method: "get",
      params: data,
    });
  },

  searchEatingReport: function (data) {
    return tmhRequest({
      url: "/health/tmh/healthreport/searcheatingreport",
      method: "get",
      params: data,
    });
  },

  searchDietReport: function (data) {
    return tmhRequest({
      url: "/health/tmh/healthreport/searchdietreport",
      method: "get",
      params: data,
    });
  },
  

  createHealthReport: function (data) {
    return tmhRequest({
      url: "/health/tmh/healthreport/createhealthreport",
      method: "post",
      data: data,
    });
  },
};



// WEBPACK FOOTER //
// ./src/api/tmh/health/healthreport.js